module.exports = ".loader { width: 60px; margin: 0 auto; position: relative; top: 50px; }\n.card { height: 130px; }\np { margin-top: 40px; margin-left: -10px; color: #444; }\n.overlay-load { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-pack: center; -ms-flex-pack: center; justify-content: center; -webkit-box-align: center; -ms-flex-align: center; align-items: center; position: fixed; background: rgba(0, 0, 0, 0.6); top: 0; bottom: 0; left: 0; right: 0; z-index: 99999; }"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/loading/loading.component.css
// module id = ./src/app/shared/loading/loading.component.css
// module chunks = main